module.exports = __webpack_public_path__ + "img/papermaking_1200x800.041685fc.svg";